import {
  FinanceEnumsFilterTypeEnum,
  FinanceEnumsStatementMarketTypeEnum,
} from '@genial/services/dist/models';

import { FixedIncomeStatementsParamsProps, StatementOptionQuery } from './types';

interface SelectItem {
  label: string;
  value: StatementOptionQuery;
}

export const statementsItemsSelect = {
  title: { default: 'Selecione o tipo:', modal: 'Tipo' },
  items: [
    { label: 'CONTA CORRENTE', value: 'current-account' },
    { label: 'RENDA FIXA', value: 'fixed-income' },
    { label: 'FUNDOS', value: 'fund' },
    { label: 'PREVIDÊNCIA', value: 'pension' },
    { label: 'TESOURO DIRETO', value: 'direct-treasury' },
  ] as SelectItem[],
};

export const statementsRadioItemsSelect = {
  title: { default: 'Período', modal: 'Período' },
  items: [
    { label: 'Últimos 15 dias', value: 'LastFifthDays' },
    { label: 'Mensal', value: 'Month' },
    { label: 'Anual', value: 'Annual' },
    { label: 'Outros', value: 'Other' },
  ],
};

export const statementOptionToMarketType: Record<string, FinanceEnumsStatementMarketTypeEnum> = {
  'current-account': 'CurrentAccount',
  fund: 'Fund',
  pension: 'Pension',
};

export const initialFilterTypedOption = statementsRadioItemsSelect.items[0]
  .value as StatementOptionQuery;
export const initialSelectedOption = statementsItemsSelect.items[0].value;

export const statementsRadioOptionsDisabled: StatementOptionQuery[] = ['direct-treasury'];

export const defaultParams = {
  filterType: initialFilterTypedOption as FinanceEnumsFilterTypeEnum,
} as Partial<FixedIncomeStatementsParamsProps>;
